import React from 'react'
import {
  amtNumStr,
  amtStr,
} from '@ifca-root/react-component/src/helpers/StringNumberFunction/numFormatter'
import { formatDate } from 'helpers/StringNumberFunction/FormatDate'

interface DetailProps {
  listEl: any
  listStatus: string
  userList: any
  documentListing?: any
  mode?: string
}

export const ProvisionImpairmentDetailContent = (props: DetailProps) => {
  const { listEl, listStatus, userList } = props

  return (
    <>
      <div className="content-wrap full">
        <div className="desc" style={{ color: 'grey' }}>
          {'Asset Name'}
        </div>
        <div className="mdDesc text-noflow">{listEl?.Asset?.name}</div>
      </div>

      <div className="content-wrap left">
        <div className="desc" style={{ color: 'grey' }}>
          {'Asset Start Date'}
        </div>
        <div className="mdDesc text-noflow" style={{ fontSize: '11px' }}>
          {formatDate(listEl?.Asset?.start_use_date)}
        </div>
      </div>

      <div className="content-wrap right">
        <div className="desc" style={{ color: 'grey' }}>
          {'Model No'}
        </div>
        <div className="mdDesc text-noflow" style={{ fontSize: '11px' }}>
          {listEl?.Asset?.model_no || 'N/A'}
        </div>
      </div>

      <div className="content-wrap full">
        <div className="desc" style={{ color: 'grey' }}>
          {'Impairment Amount'}
        </div>
        <div className="mdDesc text-noflow" style={{ fontSize: '11px' }}>
          {listEl?.impairment_amount || 'N/A'}
        </div>
      </div>

      <div className="content-wrap left">
        <div className="desc" style={{ color: 'grey' }}>
          {'Old Accumulated Impairment'}
        </div>
        <div className="mdDesc text-noflow" style={{ fontSize: '11px' }}>
          {amtStr(listEl?.old_accumulated_impairment)}
        </div>
      </div>

      <div className="content-wrap right">
        <div className="desc" style={{ color: 'grey' }}>
          {'New Accumulated Impairment'}
        </div>
        <div className="mdDesc text-noflow" style={{ fontSize: '11px' }}>
          {amtStr(listEl?.new_accumulated_impairment)}
        </div>
      </div>

      <div className="content-wrap left">
        <div className="desc" style={{ color: 'grey' }}>
          {'Old Net Book Value'}
        </div>
        <div className="mdDesc text-noflow" style={{ fontSize: '11px' }}>
          {amtStr(listEl?.old_net_book_value)}
        </div>
      </div>

      <div className="content-wrap right">
        <div className="desc" style={{ color: 'grey' }}>
          {'New Net Book Value'}
        </div>
        <div className="mdDesc text-noflow" style={{ fontSize: '11px' }}>
          {amtStr(listEl?.new_net_book_value)}
        </div>
      </div>

      <div className="content-wrap left">
        <div className="desc" style={{ color: 'grey' }}>
          {'Submitted Date'}
        </div>
        <div className="mdDesc text-noflow" style={{ fontSize: '11px' }}>
          {formatDate(listEl?.submittedTs)}
        </div>
      </div>

      <div className="content-wrap right">
        <div className="desc" style={{ color: 'grey' }}>
          {'Submitted By'}
        </div>
        <div className="mdDesc text-noflow" style={{ fontSize: '11px' }}>
          {userList?.filter(user => user.ID == listEl?.submittedBy)[0]?.name ||
            'N/A'}
        </div>
      </div>

      {listStatus === 'COMPLETED' && (
        <>
          <div className="content-wrap left">
            <div className="desc" style={{ color: 'grey' }}>
              {'Approved Date'}
            </div>
            <div className="mdDesc text-noflow" style={{ fontSize: '11px' }}>
              {formatDate(listEl?.approvedTs)}
            </div>
          </div>
          <div className="content-wrap right">
            <div className="desc" style={{ color: 'grey' }}>
              {'Approved By'}
            </div>
            <div className="mdDesc text-noflow" style={{ fontSize: '11px' }}>
              {userList?.filter(user => user.ID == listEl?.approvedBy)[0]
                ?.name || 'N/A'}
            </div>
          </div>
        </>
      )}

      {listStatus === 'REJECTED' && (
        <>
          <div className="content-wrap left">
            <div className="desc" style={{ color: 'grey' }}>
              {'Rejection Date'}
            </div>
            <div className="mdDesc text-noflow" style={{ fontSize: '11px' }}>
              {formatDate(listEl?.RejectionDate)}
            </div>
          </div>
          <div className="content-wrap right">
            <div className="desc" style={{ color: 'grey' }}>
              {'Rejection Remark'}
            </div>
            <div className="mdDesc text-noflow" style={{ fontSize: '11px' }}>
              {listEl?.RejectionRemark || 'N/A'}
            </div>
          </div>
        </>
      )}
    </>
  )
}
